import React from 'react'

const AccessIcon = (props) => {
    return (
        <img src={props.selected ? "/assets/icons/access.svg" : "/assets/icons/access.svg"}
             alt="Profile access settings"
             style={props.style}
        />
    )
}

export default AccessIcon